import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { vinculosTiposAtendimentoColumns } from './columns/_columns'
import { FormularioTipoAtendimentoList } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const TiposAtendimentoVinculosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => vinculosTiposAtendimentoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum vínculo encontrado'
      description={`Revise o tipo de atendimento, a ${t('empresa.label.lowercase')} ou a unidade.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum vínculo cadastrado'
      description='Use “Novo vínculo” para vincular o formulário a tipos de atendimento.'
    />
  )

  return (
    <CustomTable<FormularioTipoAtendimentoList>
      id='kt_table_vinculos_tipos_atendimento'
      ariaLabel='Vínculos por tipo de atendimento'
      itemLabel={{ singular: 'vínculo', plural: 'vínculos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
